import type { IconProps } from "./types";

interface SadFileIconProps extends IconProps {
  fileColor?: string;
}

// Hardcoded color values (previously imported from style.module.css)
const EASIL_BLACK = "#2c2e2f";
const EASIL_GRAY_X_DARK = "#57595D";

const SadFileIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title,
  fileColor
}: SadFileIconProps) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || "66"}
    height={height || size || "92"}
    viewBox="0 0 66 92"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || EASIL_GRAY_X_DARK}
  >
    <title>{title}</title>
    <g fillRule="nonzero" fill="none">
      <path
        d="M60.697 90.333H14.684a5 5 0 0 1-5-5V15.426a5 5 0 0 1 5-5h46.013a5 5 0 0 1 5 5v69.908a5 5 0 0 1-5 4.999z"
        fill={fileColor || "#FEDD4E"}
      />
      <g fill={color || EASIL_BLACK} transform="translate(1 2)">
        <path d="M2.374 13.547a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM14.233 79.544h-7a1.5 1.5 0 1 0 0 3h7a1.5 1.5 0 1 0 0-3zM4.044.516A3.483 3.483 0 0 0 .874 4v4.047a1.5 1.5 0 1 0 3 0V4c0-.255.198-.474.452-.498A1.5 1.5 0 1 0 4.044.516zM18.184.5h-7a1.5 1.5 0 1 0 0 3h7a1.5 1.5 0 1 0 0-3zM2.374 55.547a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM2.374 27.547a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM25.184 3.5h7a1.5 1.5 0 1 0 0-3h-7a1.5 1.5 0 1 0 0 3zM2.374 69.547a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM2.374 41.546a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM42.233 79.544h-7a1.5 1.5 0 0 0 0 3h7a1.5 1.5 0 0 0 0-3zM56.486 79.476a.48.48 0 0 1-.253.068h-7a1.5 1.5 0 0 0 0 3h7a3.51 3.51 0 0 0 1.778-.484 1.501 1.501 0 0 0-1.525-2.584zM58.233 51.621a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM58.233 65.621a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM58.233 23.621a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 1 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM58.233 37.621a1.5 1.5 0 0 0-1.5 1.5v7a1.5 1.5 0 0 0 3 0v-7a1.5 1.5 0 0 0-1.5-1.5zM43.453 17.552l.022-4.391a1.5 1.5 0 0 0-1.492-1.507h-.008a1.5 1.5 0 0 0-1.5 1.493l-.029 5.84a1.5 1.5 0 0 0 1.477 1.507l1.16.018h.023a1.5 1.5 0 0 0 .347-2.96zM28.233 79.544h-7a1.5 1.5 0 1 0 0 3h7a1.5 1.5 0 1 0 0-3zM54.715 17.694l-4.586-.072c-.852-.028-1.511.648-1.523 1.477a1.5 1.5 0 0 0 1.477 1.523l6.999.11h.023c.19 0 .371-.039.539-.104a1.497 1.497 0 0 0 1.617-.286 1.499 1.499 0 0 0 .065-2.12l-4.792-5.102a1.5 1.5 0 0 0-2.186 2.054l2.367 2.52zM49.676 10.139a1.5 1.5 0 0 0 .066-2.12l-4.793-5.103c-.378-.402-.92-.525-1.421-.412l.002-.498A1.497 1.497 0 0 0 42.03.5h-2.846a1.5 1.5 0 1 0 0 3h1.338l-.013 2.646a1.5 1.5 0 0 0 1.492 1.507h.008a1.5 1.5 0 0 0 1.5-1.493l.002-.393 4.043 4.304c.296.314.694.473 1.094.473.369.002.738-.133 1.028-.405zM38.397 54.513a1.59 1.59 0 0 0 1.336.713c.346 0 .687-.108.963-.31.366-.244.611-.616.688-1.048a1.65 1.65 0 0 0-.284-1.251c-.032-.048-3.464-4.796-9.41-4.796-2.405 0-5.977.787-9.335 4.537-.067.075-.112.127-.128.142l-.052.054c-.52.715-.341 1.769.378 2.292.336.274.76.392 1.192.339.439-.057.84-.29 1.105-.643.029-.028.059-.062.097-.104 1.899-2.146 4.273-3.327 6.687-3.327 3.792-.001 6.292 2.827 6.763 3.402z" />
        <circle cx="24.831" cy="40.71" r="2.592" />
        <path d="M38.55 43.303a2.595 2.595 0 0 0 2.593-2.592 2.595 2.595 0 0 0-2.593-2.592 2.595 2.595 0 0 0-2.592 2.592 2.595 2.595 0 0 0 2.592 2.592z" />
      </g>
    </g>
  </svg>
);

export default SadFileIcon;
